"use client";

import BlockedPopup from "@/components/atoms/Blocked";
import { useAuth } from "@/graphql/auth";

export default function BlockedProvider() {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
    <BlockedPopup
      isVisible={user?.isBlocked === true}
    />
  );
}